export default (theme: any) => ({
    root: {
        flexGrow: 1,
    },

    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        borderRadius: '2px',
        [theme.breakpoints.down('sm')]: {
            margin: '0px',
        },
    },

    topCard: {
        [theme.breakpoints.down('sm')]: {
            paddingBottom: '0px !important',
        },
    },
})
